import React, { useContext } from "react";
import { styled, css } from "../styling";
import { Surface } from "../Surface";
import { AccordionContext } from "./Accordion";
const StyledSurface = styled(Surface) `
  display: flex;
  flex-direction: column;

  ${(props) => {
    const active = props.$index === props.$activeIndex && props.$activeIndex !== undefined;
    return css `
      flex: ${active ? 1 : 0};
      &:not(:last-child) {
        margin-bottom: ${active ? "0.5em" : 0};
        border-bottom: 1px solid
          ${!active &&
        (props.$activeIndex === undefined ||
            props.$index !== props.$activeIndex - 1)
        ? props.theme.colors.accent
        : "transparent"};
      }

      &:not(:first-child) {
        margin-top: ${active ? "0.5em" : 0};
      }
    `;
}}
  transition: 0.3s ease-out;
  transition-property: margin, flex;
`;
export const AccordionItemContext = React.createContext(-1);
export const AccordionItem = (props) => {
    const { activeIndex } = useContext(AccordionContext);
    return (React.createElement(AccordionItemContext.Provider, { value: props.index },
        React.createElement(StyledSurface, { className: "surface", "$index": props.index, "$activeIndex": activeIndex, elevation: 2 }, props.children)));
};
//# sourceMappingURL=AccordionItem.js.map